import {bffInstance} from "../../api/axiosInstance";

export const fetchApplicationCategory = async () => {
    const res = await bffInstance.get<any>('/applicationCategories')
    return res.data;
};

export const fetchAdminApplications = async () => {
    const res = await bffInstance.get<Record<any, any>[]>('/applications');
    return res.data;
};

export const createNewApplication = async (applicationRequestBody: Partial<any>) => {
    const res = await bffInstance.post<Record<any, any>[]>('/applications', applicationRequestBody);
    return res.data;
};

export const createNewWorkflow = async (workflowRequestBody: Partial<any>) => {
    const res = await bffInstance.post<Record<any, any>[]>('/workflows', workflowRequestBody);
    return res.data;
};

export const updateAdminApplication = async (appId: string, applicationRequestBody: Partial<any>) => {
    const res = await bffInstance.patch<Record<any, any>[]>(`/applications/${appId}`, applicationRequestBody);
    return res.data;
};

export const updateAdminWorkflow = async (workflowId: string, applicationRequestBody: Partial<any>) => {
    const res = await bffInstance.patch<Record<any, any>[]>(`workflows/${workflowId}`, applicationRequestBody);
    return res.data;
};

export const fetchAdminWorkflows = async () => {
    const res = await bffInstance.get<Record<any, any>[]>(`workflows`);
    return res.data;
};

export const searchByUserId = async (searchQuery: string) => {
    const res = await bffInstance.get<Record<any, any>[]>(`search/user/${searchQuery}`);
    return res.data;
};

export const getUserAppAndWorkflowNames = async (userId: string) => {
    const res = await bffInstance.get<Record<any, any>[]>(`/app-workflow/names/${userId}`);
    return res.data;
};

export const fetchAdminPermissions = async () => {
    const res = await bffInstance.get<Record<any, any>[]>(`/permissions`);
    return res.data;
};

export const updateAdminPermissions = async (appId: string, workflowId: string, permissionRequestBody: Partial<any>) => {
    const res = await bffInstance.patch<Record<any, any>[]>(`/permissions/${appId || workflowId}`, permissionRequestBody);
    return res.data;
};